import { useState } from 'react';
import type { Brand } from '../../lib/brand.ts';
import { cn } from '../../lib/utils.ts';

// web-instance-identity: לוגו החברה בלבד, בלי טקסט לידו (החלטת הבעלים 2026-10-19) — אריח מרובע, הלוגו בתוכו (object-fit:
// contain), לבן בבהיר / כרטיס בכהה; רק <img> (SVG לא מורץ). השם רק ב-title/aria-label ובכותרת הלשונית. בלי לוגו, או כשהתמונה
// לא נטענה — אותו אריח עם האות הראשונה של שם הסביבה (--link על --primary-soft), בלי תמונה שבורה. 40 בפס, 96 בתפריט ובכניסה.
const SIZE = {
  40: 'size-10 rounded-md p-[3px] text-lg',
  96: 'size-24 rounded-lg p-1.5 text-5xl',
} as const;

export function CompanyLogo({ brand, size, className }: { brand: Brand | null; size: keyof typeof SIZE; className?: string }) {
  const [broken, setBroken] = useState<string | null>(null);
  const name = brand?.nameHe ?? '';
  const src = brand?.logoUrl && broken !== brand.logoUrl ? brand.logoUrl : null;
  const a11y = { role: 'img', 'aria-label': name, title: name } as const;
  if (src)
    return (
      <span {...a11y} className={cn('grid shrink-0 place-items-center overflow-hidden border border-logo-tile-border bg-logo-tile', SIZE[size], className)} data-testid="company-logo" data-kind="image">
        <img src={src} alt="" className="size-full object-contain" onError={() => setBroken(src)} />
      </span>
    );
  return (
    <span {...a11y} className={cn('grid shrink-0 place-items-center bg-primary-soft font-bold leading-none text-link', SIZE[size], className)} data-testid="company-logo" data-kind="letter">
      {Array.from(name.trim())[0] ?? ''}
    </span>
  );
}
